import { useCallback, useEffect, useState } from 'react';

const etatInitial = { charge:false, autorisee:false, connexion:false, erreur:'' };

export default function BoutiqueClubPayplugRecetteAuth({ actif, clientSupabase, campagneId, groupeSlug, onAutorisation }) {
  const [etat, setEtat] = useState(etatInitial);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const verifier = useCallback(async () => {
    if (!actif || !clientSupabase?.auth?.getSession || !clientSupabase?.functions?.invoke) {
      setEtat(etatInitial); onAutorisation?.(false); return false;
    }
    setEtat((courant) => ({ ...courant, charge:true, erreur:'' }));
    const { data:{ session } = {} } = await clientSupabase.auth.getSession();
    if (!session?.access_token) {
      setEtat({ ...etatInitial, charge:false }); onAutorisation?.(false); return false;
    }
    const { data, error } = await clientSupabase.functions.invoke('boutiqueclub-payplug', { body:{
      action:'STATUT_AUTORISATION', groupe_slug:String(groupeSlug || '').toLowerCase(), campagne_id:campagneId,
    }});
    const autorisee = !error && data?.autorisee === true;
    setEtat({ ...etatInitial, charge:false, autorisee, erreur:autorisee ? '' : 'Ce compte ne dispose pas de l’autorisation PayPlug TEST pour cette campagne.' });
    onAutorisation?.(autorisee);
    return autorisee;
  }, [actif, campagneId, clientSupabase, groupeSlug, onAutorisation]);

  useEffect(() => { verifier().catch(() => {
    setEtat({ ...etatInitial, erreur:'La session de recette ne peut pas être vérifiée.' });
    onAutorisation?.(false);
  }); }, [verifier, onAutorisation]);

  if (!actif) return null;

  const connecter = async (evenement) => {
    evenement.preventDefault();
    if (!username.trim() || !password) return setEtat((courant) => ({ ...courant, erreur:'Renseignez votre identifiant et votre mot de passe CRM Clubs.' }));
    setEtat((courant) => ({ ...courant, connexion:true, erreur:'' }));
    try {
      const { data, error } = await clientSupabase.functions.invoke('auth-username', { body:{
        action:'login', groupe:'FORQUET', username:username.trim(), password,
      }});
      setPassword('');
      if (error || !data?.access_token || !data?.refresh_token) throw new Error('CONNEXION_REFUSEE');
      const session = await clientSupabase.auth.setSession({ access_token:data.access_token, refresh_token:data.refresh_token });
      if (session?.error) throw session.error;
      const autorisee = await verifier();
      if (!autorisee) setEtat((courant) => ({ ...courant, connexion:false }));
    } catch (_) {
      setPassword(''); onAutorisation?.(false);
      setEtat({ ...etatInitial, erreur:'Connexion impossible ou compte de recette non autorisé.' });
    }
  };

  if (etat.autorisee) return <div className="bc-test-payment bc-recipe-auth" role="status">
    <strong>COMPTE DE RECETTE AUTORISÉ</strong>
    <p>La session Supabase a été vérifiée côté serveur pour FORQUET et cette campagne.</p>
  </div>;

  return <form className="bc-test-payment bc-recipe-auth" onSubmit={connecter}>
    <strong>CONNEXION COMPTE DE RECETTE</strong>
    <p>PayPlug TEST est réservé aux comptes explicitement autorisés. Aucune clé privilégiée n’est utilisée dans le navigateur.</p>
    <label>Identifiant CRM Clubs<input aria-label="Identifiant compte de recette" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)}/></label>
    <label>Mot de passe<input aria-label="Mot de passe compte de recette" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)}/></label>
    <button className="bc-primary" type="submit" disabled={etat.connexion || etat.charge}>{etat.connexion || etat.charge ? 'VÉRIFICATION…' : 'SE CONNECTER POUR PAYPLUG TEST'}</button>
    {etat.erreur && <p className="bc-error" role="alert">{etat.erreur}</p>}
  </form>;
}
